import { useEffect, useLayoutEffect } from 'react';
import { useAuth } from '../context/AuthContext';

const SUPER_ADMIN_PORTAL = () => import('../pages/admin/super-admin/SuperAdminPortal');

/**
 * Dismisses the HTML splash once auth has resolved (login + app routes).
 * Preloads Admin Portal chunk for Super Admins during idle time.
 */
const AppBootstrap = () => {
  const { isLoading, isSuperAdmin } = useAuth();

  useLayoutEffect(() => {
    if (!isLoading) {
      window.__dismissAppSplash?.();
    }
  }, [isLoading]);

  useEffect(() => {
    if (isLoading || !isSuperAdmin) return;

    const preload = () => {
      SUPER_ADMIN_PORTAL().catch(() => {});
    };

    if ('requestIdleCallback' in window) {
      const id = requestIdleCallback(preload, { timeout: 2500 });
      return () => cancelIdleCallback(id);
    }

    const id = window.setTimeout(preload, 800);
    return () => window.clearTimeout(id);
  }, [isLoading, isSuperAdmin]);

  return null;
};

export default AppBootstrap;
